export default __webpack_public_path__ + "static/media/runkeeper-go-phone.fb2014ed.svg";